
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Textarea } from '@/components/ui/textarea';
import { useDealerRating } from '@/hooks/dealers/useDealerRating';
import { StarRatingInput } from './StarRatingInput';
import { Loader2 } from 'lucide-react';

interface DealerRatingModalProps {
  dealerId: string;
  dealerName: string;
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
}

export const DealerRatingModal: React.FC<DealerRatingModalProps> = ({
  dealerId,
  dealerName,
  isOpen,
  onOpenChange,
}) => {
  const { form, onSubmit, isLoading, hasExistingRating } = useDealerRating({
    dealerId,
    onSuccess: () => onOpenChange(false),
  });

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Lascia una recensione</DialogTitle>
          <DialogDescription>
            Condividi la tua esperienza con {dealerName}. La tua opinione è importante.
          </DialogDescription>
        </DialogHeader>
        {isLoading ? (
          <div className="flex justify-center items-center py-10">
            <Loader2 className="h-8 w-8 animate-spin text-primary" />
          </div>
        ) : hasExistingRating ? (
             <div className="py-4 text-center">
                <p>Hai già lasciato una recensione per questo compro oro.</p>
                 <DialogFooter className='mt-4'>
                    <Button variant="outline" onClick={() => onOpenChange(false)}>Chiudi</Button>
                </DialogFooter>
             </div>
        ) : (
            <Form {...form}>
            <form onSubmit={onSubmit} className="space-y-4">
                <FormField
                control={form.control}
                name="rating"
                render={({ field }) => (
                    <FormItem>
                    <FormLabel>La tua valutazione (obbligatoria)</FormLabel>
                    <FormControl>
                        <StarRatingInput value={field.value} onChange={field.onChange} />
                    </FormControl>
                    <FormMessage />
                    </FormItem>
                )}
                />

                <FormField
                control={form.control}
                name="comment"
                render={({ field }) => (
                    <FormItem>
                    <FormLabel>Commento (opzionale)</FormLabel>
                    <FormControl>
                        <Textarea
                        placeholder="Descrivi la tua esperienza..."
                        {...field}
                        value={field.value ?? ''}
                        />
                    </FormControl>
                    <FormMessage />
                    </FormItem>
                )}
                />
                <DialogFooter>
                    <Button type="button" variant="ghost" onClick={() => onOpenChange(false)} disabled={form.formState.isSubmitting}>Annulla</Button>
                    <Button type="submit" disabled={form.formState.isSubmitting}>
                        {form.formState.isSubmitting && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
                        Invia Recensione
                    </Button>
                </DialogFooter>
            </form>
            </Form>
        )}
      </DialogContent>
    </Dialog>
  );
};
